<template lang="html">
<div>
  <div class="user_box">
    <div class="user_left">
      <img :src="`http://ucenter.jmgo.com/avatar.php?uid=${userinfo.uid}&size=middle`" alt="">
    </div>
    <div class="user_center">
      <h2>{{userinfo.username}}</h2>
      <span>{{userinfo.mobile}}</span>
    </div>
    <router-link tag="div" to="/resetinfo" class="user_right">
      <i>&#xe600;</i>
    </router-link>
  </div>
  <nav class="user_nav">
    <ul>
      <router-link tag="li" to="/resetinfo">
        <i>&#xe601;</i>
        <span>个人信息</span>
      </router-link>
      <li>
        <i class="text_color">&#xe60d;</i>
        <span class="text_color">{{userinfo.extcredits3}}果实</span>
      </li>
      <li>
        <i class="text_color">&#xe745;</i>
        <span class="text_color">{{userinfo.friends}}好友</span>
      </li>
      <li>
        <i class="text_color">&#xe658;</i>
        <span class="text_color">{{userinfo.extcredits1}}人气</span>
      </li>
    </ul>
  </nav>

  <div class="cell_list">
    <ul>
      <router-link tag="li" to="/exchange"><i>&#xe71c;</i><span>兑换记录</span><i>&#xe6c4;</i></router-link>
      <router-link tag="li" to="/integral"><i>&#xe629;</i><span>积分兑换</span><i>&#xe6c4;</i></router-link>
      <li @click="towww"><i>&#xe619;</i><span>官方商城</span><i>&#xe6c4;</i></li>
    </ul>
    <ul>
      <!-- <li><i>&#xe610;</i><span>我的作品</span><i>&#xe6c4;</i></li> -->
      <router-link tag="li" to="/lately"><i>&#xe621;</i><span>最近评论</span><i>&#xe6c4;</i></router-link>
      <router-link tag="li" to="/sign"><i>&#xe639;</i><span>本日签到</span><i>&#xe6c4;</i></router-link>
    </ul>

  </div>
  <div class="loginout" @click="logout">退出当前账户</div>
</div>
</template>

<script>
import Vue from 'vue'
import utilAxios from '@/utils/axios'
import { Toast } from 'vant'
Vue.use(Toast)
var toast1=''
export default {
  data (){
    return{
      uid: '',
      mobile:'',
      userinfo: []
    }
  },
   beforeCreate() {
    toast1=Toast.loading({
      duration:0,
      forbidClick:true,
      mask: true,
      message: '加载中...'
    })
  },

  mounted() {
    this.uid = this.getCookie('ECS[user_id]')
    this.mobile=this.getCookie('ECS[mobile]')
    console.log(this.uid)
    this.isLogin()
    this.getUserInfo()
  },
  methods: {
    // ----获取cookie--
    trim(str) {
			return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '')
		},
    getCookie(name) {
			let result;
			let cookies = document.cookie.split(';')
			for (let i = 0; i < cookies.length; i++) {
				let cookie = this.trim(cookies[i])
				if (cookie.substring(0, name.length + 1) == (name + '=')) {
					result = decodeURIComponent(cookie.substring(name.length + 1))
				}
			}
			return result
		},
    towww(){
      window.location.href="https://www.jmgo.com/dist/#/home"
    },
    logout(){
        location.href = 'https://www.jmgo.com/mobile/user.php?act=logout&back_act='+escape('http://bbs.jmgo.com/dist/#/home');
    },
    // ----登录判断----
    isLogin() {
      if (!this.uid || this.uid=='0') {
        location.href = 'https://www.jmgo.com/mobile/user.php?act=bbslogin&sync=bbs&loginhash=&back_act='+escape('http://bbs.jmgo.com/dist/#/user');
      }/*else if(!this.mobile){
        location.href = 'https://www.jmgo.com/mobile/user.php?act=m_bind&back_act='+escape('http://bbs.jmgo.com/dist/#/user');
      }*/
    },
    getUserInfo() {
      utilAxios.get({
        url: '/new_api.php?module=home&mod=space&do=profile',
        method: 'GET',
        callback: (res) => {

          if(res.data.code == 100){
            toast1.clear();
            this.userinfo = res.data.space
          }
         
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .user_box{
    padding: 0 .2rem;
    height: 1.1rem;
    background: url('./userbg.jpg') no-repeat center;
    background-size: 100%;
    display: flex;
    align-items: center;

    .user_left{
      width: .7rem;
      height: .7rem;
      img{
        width: 100%;
        height: 100%;
        border-radius: 100%;
      }
    }
    .user_center{
      padding-left: .2rem;
      flex: 1;
      h2{
        font-size: .16rem;
        line-height: .3rem;
        color: #FFF;
      }
      span{
        display: block;
        line-height: .3rem;
        color: #FFF;
      }
    }
    .user_right{
      width: .5rem;
      height: 100%;
      line-height: 1.3rem;
      text-align: center;
      i{
        font-size: .2rem;
        color: #FFF;
      }
    }
  }
  .user_nav{
    width: 100%;
    height: .65rem;
    background: #FFF;
    ul{
      display: flex;
      li{
        flex: 1;
        display: flex;
        flex-direction: column;
        i{
          height: .4rem;
          line-height: .4rem;
          text-align: center;
          font-size: .2rem;
        }
        span{
          text-align: center;
        }
        .text_color{
          color: #ff9530;
        }
      }
    }
  }
  .loginout{
    width: 100%;
    height: .4rem;
    text-align: center;
    background: #cd2124;
    color: #fff;
    line-height: .4rem;
   margin-top:2rem;
   margin-bottom:1rem;
  }
  .cell_list{
    ul{
      margin-top: .1rem;
      background: #fff;
      li{
        cursor:pointer;
        display: flex;
        border-bottom: 1px solid #f5f5f5;
        i{
          width: .35rem;
          height: .35rem;
          display: block;
          text-align: center;
          line-height: .35rem;
          font-size: .18rem;
        }
        span{
          flex: 1;
          height: .35rem;
          line-height: .35rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/User/User.vue